module.exports = __webpack_public_path__ + "static/media/cyuce004.4ee994fe.png";